import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-devices",
  "use": "svg-devices-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-devices\">\n  <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n  <path d=\"M21.167 13c.46 0 .833.358.833.8v6.4c0 .442-.373.8-.833.8H2.833c-.46 0-.833-.358-.833-.8v-6.4c0-.442.373-.8.833-.8zM10 16H5v2h5v-2zm8 0a1 1 0 100 2 1 1 0 000-2zm3.167-13c.46 0 .833.358.833.8v6.4c0 .442-.373.8-.833.8H2.833c-.46 0-.833-.358-.833-.8V3.8c0-.442.373-.8.833-.8zM10 6H5v2h5V6zm8 0a1 1 0 100 2 1 1 0 000-2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol